(function (angular) {
  "use strict";

  var NOOP_SORT_FUNCTION = function () {
    return 0;
  };

  angular.module("Toyota.Directives").directive("tyTabs", [
    "$window",
    "$timeout",
    "CssMediaWatcher",
    function ($window, $timeout, CssMediaWatcher) {
      var controller = [
        "$scope",
        function ($scope) {
          var ctl = this;

          ctl.selectedTabId = null;

          $scope.selectedTabId = ctl.selectedTabId;

          $scope.selectTab = function (tab) {
            if (!tab.disabled && ctl.onTabChange) {
              ctl.onTabChange(tab);
              $scope.selectedTabId = tab.id;
            }
          };

          $scope.$watch("tyTabs.initialSelectedTabId", function (newValue) {
            if (newValue && ctl.selectedTabId === null) {
              ctl.selectedTabId = ctl.initialSelectedTabId;
            }
          });

          function init() {
            $scope.tabsHaveSpacing = typeof ctl.tabSpacing !== "undefined" ? ctl.tabSpacing : true;
            $scope.tabOrdering = NOOP_SORT_FUNCTION;

            if (ctl.tabOrdering) {
              $scope.tabOrdering = ctl.tabOrdering;
            }

            ctl.selectedTabId = ctl.initialSelectedTabId;
            $scope.selectedTabId = ctl.selectedTabId;
          }

          ctl.$onInit = init;
        },
      ];

      // prettier-ignore
      var template =
        '<div class="ty-tabs-scrollbar-cover" data-ty-mouse-detected-css >' +
          '<div class="ty-tabs-container" data-ng-class="{\'-underline-split\': tabsHaveSpacing}" >' +
            "<div data-ng-repeat=\"tab in tyTabs.tabs | orderBy:'title':false:tabOrdering\" " +
                 'class="ty-tab {{tyTabs.itemClass}}" ' +
                 'id="ty-tab-{{$parent.$id}}-{{tab.id}}"> ' +
              '<input type="radio" ' +
                     'name="ty-tabs-{{$parent.$id}}" ' +
                     'id="ty-tabs-{{$parent.$id}}-{{tab.id}}" ' +
                     'class="ty-tab__radio" ' +
                     'data-ng-checked="{{tyTabs.selectedTabId === tab.id}}" ' +
                     'data-ng-value="{{tab.id}}" ' +
                     'data-ng-disabled="{{tab.disabled}}">' +
              '<label for="ty-tabs-{{$parent.$id}}-{{tab.id}}" ' +
                     'class="ty-tab__select-area" ' +
                     "data-ty-mouse-detected-css " +
                     "data-ng-class=\"{'is-disabled' : tab.disabled}\" " +
                     'data-ng-click="selectTab(tab)">' +
              '<span class="ty-tab__label {{tyTabs.labelClass}}">{{tab.title}}</span>' +
              '<span class="ty-tab__label-active {{tyTabs.labelClass}}">{{ !!tab.activeTitle ? tab.activeTitle : tab.title}}</span>' +
              "</label>" +
            "</div>" +
            '<div class="ty-tab__right-spacer"></div>' +
          "</div>" +
        "</div>";

      var link = function ($scope, $element) {
        var cssMediaWatcher = CssMediaWatcher({
          $el: $element.find(".ty-tabs-container"),
          pseudoEl: "before",
          mediaProperty: "viewportWidth",
          mediaRegexes: {
            small: "^small$",
            big: "^big$",
          },
        });

        var $tabsItemsContainer = $element.find(".ty-tabs-container");
        var $tabsRightSpacer = $element.find(".ty-tab__right-spacer");
        var $tabsScrollbarCover = $element;
        var isScrollbarCovered = "is-scrollbar-covered";

        function init() {
          $scope.$watch("selectedTabId", function () {
            updateScrollPosition();
          });

          $scope.$watch("tyTabs.tabs", function () {
            $timeout(function () {
              updatePadding();
              updateScrollPosition();
            });
          });

          angular.element($window).resize(updatePadding);

          $scope.$on("did-detect-mouse", function () {
            angular.element($window).off("resize", updatePadding);
            $tabsItemsContainer.css("white-space", "");
            resetToDefault();
          });
        }

        init();

        function getSelectedTabItem() {
          var tabElementId = "#ty-tab-" + $scope.$id + "-" + $scope.selectedTabId;
          return $tabsItemsContainer.find(tabElementId);
        }

        function updateScrollPosition(animationDuration) {
          var $selectedItem = getSelectedTabItem();

          if ($selectedItem.length === 0) {
            return;
          }

          var selectedItemBounds = $selectedItem[0].getBoundingClientRect();
          var selectedItemMidpoint = (selectedItemBounds.right + selectedItemBounds.left) / 2;
          var windowMidpoint = angular.element($window).width() / 2;

          var scrollAmount = selectedItemMidpoint - windowMidpoint;
          var currentScrollPosition = $tabsItemsContainer.scrollLeft();
          var scrollToPosition = currentScrollPosition + scrollAmount;

          $tabsItemsContainer.animate({ scrollLeft: scrollToPosition }, animationDuration);
        }

        var isScrollable = false;

        function updatePadding() {
          var $tabItems = $element.find(".ty-tab");
          if ($tabItems.length === 0) {
            return;
          }

          var viewportWidth = cssMediaWatcher.getCurrentMedia().viewportWidth;

          if (!viewportWidth.is.small) {
            resetToDefault();
            return;
          }

          $tabsItemsContainer.css("white-space", "nowrap");
          $tabsItemsContainer.css("flex-wrap", "nowrap");

          var $firstItem = $tabItems.first();
          var firstItem = $firstItem[0].getBoundingClientRect();
          var $lastItem = $tabItems.last();
          var lastItem = $lastItem[0].getBoundingClientRect();

          var containerWidth = $element.outerWidth();
          var contentWidth = lastItem.right - firstItem.left;

          if (contentWidth <= containerWidth - lastItem.width / 2) {
            resetToDefault();
            return;
          }

          var firstItemWidthIncludingMargin = $firstItem.outerWidth(true);
          var lastItemWidthIncludingMargin = $lastItem.outerWidth(true);

          var paddingLeft = containerWidth / 2 - firstItemWidthIncludingMargin / 2;
          var paddingRight = containerWidth / 2 - lastItemWidthIncludingMargin / 2;

          var tabsContainerCSS = {
            "padding-left": paddingLeft,
            "padding-right": paddingRight,
            "padding-bottom": "15px",
            "text-align": "left",
            "justify-content": "normal",
          };

          $tabsItemsContainer.css(tabsContainerCSS);
          $tabsRightSpacer.css("padding-right", paddingRight);
          $tabsScrollbarCover.addClass(isScrollbarCovered);

          if (isScrollable === false) {
            updateScrollPosition(0);
            isScrollable = true;
          }
        }

        function resetToDefault() {
          $tabsItemsContainer.css({
            "white-space": "",
            "padding-left": "",
            "padding-right": "",
            "padding-bottom": "",
            "text-align": "",
            "justify-content": "",
            "flex-wrap": "",
          });
          $tabsScrollbarCover.removeClass(isScrollbarCovered);
          $tabsRightSpacer.css("padding-right", "");
          isScrollable = false;
        }
      };

      return {
        restrict: "E",
        scope: {},
        controllerAs: "tyTabs",
        controller: controller,
        bindToController: {
          tabs: "<tabs",
          tabOrdering: "<tabOrdering",
          initialSelectedTabId: "<initialSelectedTabId",
          onTabChange: "<onTabChange",
          itemClass: "@itemClass",
          labelClass: "@labelClass",
          tabSpacing: "<tabSpacing",
        },
        replace: true,
        transclude: true,
        template: template,
        link: link,
      };
    },
  ]);
})(window.angular);
